import { create } from 'zustand';

interface SmartOfferStore {
  showSmartOffer: boolean;
  setShowSmartOffer: (showSmartOffer: boolean) => void;
  showRating: boolean;
  setShowRating: (showRating: boolean) => void;
  showSideInComponent: boolean;
  setShowSideInComponent: (showSideInComponent: boolean) => void;
  showInLineSmartOffer: boolean;
  setShowInLineSmartOffer: (showInLineSmartOffer: boolean) => void;
  currentPathname: string | null;
  setCurrentPathname: (currentPathname: string | null) => void;
}

export const useSmartOfferStore = create<SmartOfferStore>()((set) => ({
  showSmartOffer: false,
  setShowSmartOffer: (showSmartOffer: boolean) => set({ showSmartOffer }),
  showRating: true,
  setShowRating: (showRating: boolean) => set({ showRating }),
  showSideInComponent: true,
  setShowSideInComponent: (showSideInComponent: boolean) => set({ showSideInComponent }),
  showInLineSmartOffer: false,
  setShowInLineSmartOffer: (showInLineSmartOffer: boolean) => set({ showInLineSmartOffer }),
  currentPathname: null,
  setCurrentPathname: (currentPathname: string | null) => set({ currentPathname }),
}));
